import { z } from 'zod';
import { postDtoSchema } from './dto/post.js';
import { targetDtoSchema } from './dto/target.js';
import { ingestionStatusSchema } from './dto/system.js';
export const SSE_ENDPOINT = '/api/stream';
/** Comment frame cadence. Keeps proxies from closing an idle stream. */
export const SSE_HEARTBEAT_MS = 20_000;
export const SSE_EVENT = {
    /** A post was persisted for the first time. `id` of the frame is `post.seq`. */
    POST_CREATED: 'post.created',
    /** Read / pinned / tags / note changed — sent so other open tabs stay in sync. */
    POST_UPDATED: 'post.updated',
    POST_DELETED: 'post.deleted',
    TARGET_UPSERTED: 'target.upserted',
    TARGET_DELETED: 'target.deleted',
    INGESTION_STATUS: 'ingestion.status',
};
export const ssePostCreatedSchema = z.object({
    event: z.literal(SSE_EVENT.POST_CREATED),
    data: postDtoSchema,
});
export const ssePostUpdatedSchema = z.object({
    event: z.literal(SSE_EVENT.POST_UPDATED),
    data: postDtoSchema,
});
export const ssePostDeletedSchema = z.object({
    event: z.literal(SSE_EVENT.POST_DELETED),
    data: z.object({ id: z.string() }),
});
export const sseTargetUpsertedSchema = z.object({
    event: z.literal(SSE_EVENT.TARGET_UPSERTED),
    data: targetDtoSchema,
});
export const sseTargetDeletedSchema = z.object({
    event: z.literal(SSE_EVENT.TARGET_DELETED),
    data: z.object({ id: z.string() }),
});
export const sseIngestionStatusSchema = z.object({
    event: z.literal(SSE_EVENT.INGESTION_STATUS),
    data: ingestionStatusSchema,
});
export const sseEventSchema = z.discriminatedUnion('event', [
    ssePostCreatedSchema,
    ssePostUpdatedSchema,
    ssePostDeletedSchema,
    sseTargetUpsertedSchema,
    sseTargetDeletedSchema,
    sseIngestionStatusSchema,
]);
//# sourceMappingURL=sse.js.map